var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container dental-order-list" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _vm._v("口腔订单列表"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "搜索条件" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.searchType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "searchType", $$v)
                        },
                        expression: "searchForm.searchType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "订单编号", value: "orderNo" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "套餐名", value: "packageName" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "下单人手机", value: "customerPhone" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入关键词", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearch($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.keyword,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "keyword", $$v)
                        },
                        expression: "searchForm.keyword",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-input__icon el-icon-search",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.orderStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orderStatus", $$v)
                        },
                        expression: "searchForm.orderStatus",
                      },
                    },
                    _vm._l(_vm.orderStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "预约状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.appointmentStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:dental:order:export"],
                          expression: "['admin:dental:order:export']",
                        },
                      ],
                      attrs: { type: "success", icon: "el-icon-download" },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v("导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                size: "small",
                border: "",
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#303133",
                },
                "highlight-current-row": "",
                stripe: "",
                "row-style": { height: "52px" },
                "cell-style": { padding: "0px" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "180",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            staticClass: "text-nowrap",
                            attrs: { type: "primary", underline: false },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleViewDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.orderNo))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "套餐名",
                  "min-width": "120",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: "检查人姓名",
                  "min-width": "100",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userPhone",
                  label: "联系电话",
                  "min-width": "120",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderStatus",
                  label: "订单状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getPaymentStatusType(
                                scope.row.orderStatus
                              ),
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.orderStatusName) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "预约状态",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(scope.row.status),
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.statusName ||
                                    _vm.getOrderStatusName(scope.row.status)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              !_vm.isSupplier
                ? _c("el-table-column", {
                    attrs: {
                      prop: "wechatPayAmount",
                      label: "微信支付",
                      "min-width": "100",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSupplier
                ? _c("el-table-column", {
                    attrs: {
                      prop: "fuDouDeduction",
                      label: "福豆支付",
                      "min-width": "100",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isSupplier
                ? _c("el-table-column", {
                    attrs: {
                      prop: "paidPrice",
                      label: "订单金额",
                      "min-width": "100",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  "min-width": "160",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "inspectionTime",
                  label: "预约时间",
                  "min-width": "160",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "320",
                  align: "center",
                  fixed: "right",
                  "header-cell-style": {
                    background: "#f5f7fa",
                    color: "#303133",
                    fontWeight: "bold",
                    fontSize: "12px",
                    height: "48px",
                    padding: "0",
                    lineHeight: "48px",
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "查看详情",
                                  placement: "top",
                                  effect: "light",
                                  enterable: false,
                                  "hide-after": 0,
                                },
                              },
                              [
                                _c("el-button", {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["admin:dental:order:detail"],
                                      expression:
                                        "['admin:dental:order:detail']",
                                    },
                                  ],
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-view",
                                    size: "mini",
                                    circle: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleViewDetail(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            scope.row.orderStatus !== 1
                              ? [
                                  _vm.canCancel(scope.row) &&
                                  !scope.row.hideActions
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "取消订单",
                                            placement: "top",
                                            effect: "light",
                                            enterable: false,
                                            "hide-after": 0,
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: ["admin:order:cancel"],
                                                expression:
                                                  "['admin:order:cancel']",
                                              },
                                            ],
                                            attrs: {
                                              type: "danger",
                                              icon: "el-icon-close",
                                              size: "mini",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleCancelOrder(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canEdit(scope.row) &&
                                  !scope.row.hideActions
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "修改地址",
                                            placement: "top",
                                            effect: "light",
                                            enterable: false,
                                            "hide-after": 0,
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "admin:dental:order:update",
                                                ],
                                                expression:
                                                  "['admin:dental:order:update']",
                                              },
                                            ],
                                            attrs: {
                                              type: "warning",
                                              icon: "el-icon-edit-outline",
                                              size: "mini",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleEditAddress(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canEdit(scope.row) &&
                                  !scope.row.hideActions
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "更新预约状态",
                                            placement: "top",
                                            effect: "light",
                                            enterable: false,
                                            "hide-after": 0,
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "admin:dental:order:status",
                                                ],
                                                expression:
                                                  "['admin:dental:order:status']",
                                              },
                                            ],
                                            attrs: {
                                              type: "info",
                                              icon: "el-icon-s-flag",
                                              size: "mini",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleChangeStatus(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canUploadResult(scope.row) &&
                                  !scope.row.hideActions
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "上传检查结果",
                                            placement: "top",
                                            effect: "light",
                                            enterable: false,
                                            "hide-after": 0,
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "admin:dental:order:upload",
                                                ],
                                                expression:
                                                  "['admin:dental:order:upload']",
                                              },
                                            ],
                                            attrs: {
                                              type: "success",
                                              icon: "el-icon-upload2",
                                              size: "mini",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleUploadResult(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canShip(scope.row) &&
                                  !scope.row.hideActions
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: "发货",
                                            placement: "top",
                                            effect: "light",
                                            enterable: false,
                                            "hide-after": 0,
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "admin:dental:order:status",
                                                ],
                                                expression:
                                                  "['admin:dental:order:status']",
                                              },
                                            ],
                                            attrs: {
                                              type: "success",
                                              icon: "el-icon-truck",
                                              size: "mini",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handleShipping(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canApplyAftersale(scope.row) &&
                                  !scope.row.hideActions
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: [
                                                "admin:order:aftersale:create",
                                              ],
                                              expression:
                                                "['admin:order:aftersale:create']",
                                            },
                                          ],
                                          attrs: {
                                            content: "售后申请",
                                            placement: "top",
                                            effect: "light",
                                            enterable: false,
                                            "hide-after": 0,
                                          },
                                        },
                                        [
                                          _c("el-button", {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "admin:dental:order:detail",
                                                ],
                                                expression:
                                                  "['admin:dental:order:detail']",
                                              },
                                            ],
                                            attrs: {
                                              type: "warning",
                                              icon: "el-icon-service",
                                              size: "mini",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.handerAftersale(0, {
                                                  orderNo: scope.row.orderNo,
                                                })
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.searchForm, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.searchForm, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderSend", { ref: "orderSendRef", on: { doRefresh: _vm.getList } }),
      _vm._v(" "),
      _c("ChangeReceive", {
        ref: "changeReceiveRef",
        on: { doRefresh: _vm.getList },
      }),
      _vm._v(" "),
      _c("CancelOrder", {
        ref: "cancelOrderRef",
        on: { doRefresh: _vm.getList },
      }),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "订单详情",
            visible: _vm.detailDialogVisible,
            direction: "rtl",
            size: "65%",
            "before-close": _vm.handleDialogClose,
            "modal-append-to-body": false,
            wrapperClosable: false,
            "custom-class": "dental-order-detail-drawer",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "drawer-container",
            },
            [
              _vm.isSupplier
                ? _c("div", [
                    _c("div", { staticClass: "drawer-header" }, [
                      _c("span", { staticClass: "drawer-title" }, [
                        _vm._v("订单详情"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "drawer-status" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getOrderStatusType(
                                  _vm.orderDetail.status
                                ),
                                size: "medium",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.orderDetail.statusName ||
                                    _vm.getOrderStatusName(
                                      _vm.orderDetail.status
                                    )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-section animated-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("基础信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("订单编号："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.orderNo)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("订单状态："),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getPaymentStatusType(
                                            _vm.orderDetail.orderStatus
                                          ),
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.orderDetail.orderStatusName
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约状态："),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getOrderStatusType(
                                            _vm.orderDetail.status
                                          ),
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.orderDetail.statusName ||
                                                _vm.getOrderStatusName(
                                                  _vm.orderDetail.status
                                                )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("下单人称呼："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.userName)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("下单人手机号："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.userPhone)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("下单时间："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.createTime)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-section animated-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("商品信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("商品名称："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.productName)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.orderDetail.mainImage
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("商品图片："),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "product-image" },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            "max-width": "200px",
                                            "max-height": "200px",
                                          },
                                          attrs: {
                                            src: _vm.orderDetail.mainImage,
                                            alt: "产品图片",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-section animated-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("预约信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("检查人姓名："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.userName)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约手机号："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.userPhone)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约时间："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.inspectionTime || "暂无"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约诊所："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDetail.dentalName || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("诊所地址："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.dentalAddress || "暂无"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.orderDetail.receiverName ||
                    _vm.orderDetail.receiverPhone ||
                    _vm.orderDetail.receiverDetailAddr
                      ? _c(
                          "div",
                          { staticClass: "detail-section animated-section" },
                          [
                            _c("h3", { staticClass: "section-title" }, [
                              _vm._v("物流信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货人："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverName || "暂无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货人手机："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverPhone ||
                                            "暂无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货地址："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverDetailAddr ||
                                            "暂无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.orderDetail.deliveryCompany ||
                            _vm.orderDetail.deliveryNo
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "detail-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("物流公司："),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDetail
                                                  .deliveryCompany || "暂无"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.orderDetail.deliveryNo
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "detail-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("物流单号："),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDetail.deliveryNo ||
                                                  "暂无"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.orderDetail.deliveryTime
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "detail-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("发货时间："),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDetail.deliveryTime ||
                                                  "暂无"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.orderDetail.deliveryStatusName
                              ? _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c("el-col", { attrs: { span: 24 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "detail-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("物流状态："),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.orderDetail
                                                  .deliveryStatusName || "暂无"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "drawer-header" }, [
                      _c("span", { staticClass: "drawer-title" }, [
                        _vm._v("订单编号：" + _vm._s(_vm.orderDetail.orderNo)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "drawer-status" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getOrderStatusType(
                                  _vm.orderDetail.status
                                ),
                                size: "medium",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getOrderStatusName(_vm.orderDetail.status)
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-section animated-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("基础信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("订单编号："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.orderNo)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("订单状态："),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getPaymentStatusType(
                                            _vm.orderDetail.orderStatus
                                          ),
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.orderDetail.orderStatusName
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约状态："),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getOrderStatusType(
                                            _vm.orderDetail.status
                                          ),
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.orderDetail.statusName ||
                                                _vm.getOrderStatusName(
                                                  _vm.orderDetail.status
                                                )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("下单人称呼："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.userName)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("下单人手机："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.userPhone)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("下单时间："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.createTime)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("支付方式："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.payTypeName)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("支付时间："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDetail.payTime || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("支付交易号："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.transactionId || "暂无"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("来源类型："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.sourceType === 1
                                        ? "小程序"
                                        : _vm.orderDetail.sourceType === 2
                                        ? "APP"
                                        : _vm.orderDetail.sourceType === 3
                                        ? "H5"
                                        : "未知"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("检查结果："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDetail.result ? "有" : "无")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("更新时间："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDetail.updateTime || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.orderDetail.remark || _vm.orderDetail.userRemark
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("用户备注："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.userRemark || "无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 12 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("商家备注："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.orderDetail.remark || "无")
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-section animated-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("商品信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("商品名称："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.productName)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("商品原价："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value price" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.originalPrice ||
                                        _vm.orderDetail.price
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("商品售价："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value price" }, [
                                  _vm._v(_vm._s(_vm.orderDetail.price)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            !_vm.isSupplier
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("订单价格："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value price" }, [
                                      _vm._v(
                                        _vm._s(_vm.orderDetail.orderPrice)
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约费用："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value price" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.appointmentFee || "0"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("材料费用："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value price" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDetail.materialFee || "0")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            !_vm.isSupplier
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("运费："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value price" }, [
                                      _vm._v(
                                        _vm._s(_vm.orderDetail.freight || "0")
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            !_vm.isSupplier
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("已支付金额："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value price" }, [
                                      _vm._v(
                                        _vm._s(_vm.orderDetail.paidPrice || "0")
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isSupplier
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("微信支付金额："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value price" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.wechatPayAmount || "0"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isSupplier
                              ? _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("福豆支付金额："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value price" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.fuDouDeduction || "0"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isSupplier
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("优惠券金额："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value price" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.couponPrice || "0"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.orderDetail.discount
                                  ? _c("el-col", { attrs: { span: 8 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "detail-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("优惠折扣："),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "value" }, [
                                            _vm._v(
                                              _vm._s(_vm.orderDetail.discount)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.orderDetail.mainImage
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("商品图片："),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "product-image" },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            "max-width": "200px",
                                            "max-height": "200px",
                                          },
                                          attrs: {
                                            src: _vm.orderDetail.mainImage,
                                            alt: "产品图片",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-section animated-section" },
                      [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("预约信息"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约诊所："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(_vm.orderDetail.dentalName || "暂无")
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("诊所地址："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.dentalAddress || "暂无"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "detail-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预约时间："),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.orderDetail.inspectionTime || "暂无"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.orderDetail.receiverName ||
                        _vm.orderDetail.receiverPhone ||
                        _vm.orderDetail.receiverDetailAddr
                          ? _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货人姓名："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverName || "暂无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货人电话："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverPhone ||
                                            "暂无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货详细地址："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverDetailAddr ||
                                            "暂无"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.orderDetail.result
                      ? _c(
                          "div",
                          { staticClass: "detail-section animated-section" },
                          [
                            _c("h3", { staticClass: "section-title" }, [
                              _vm._v("检查结果"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("div", {
                                      staticClass: "result-content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.orderDetail.result
                                        ),
                                      },
                                    }),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.orderDetail.trackingNumber
                      ? _c(
                          "div",
                          { staticClass: "detail-section animated-section" },
                          [
                            _c("h3", { staticClass: "section-title" }, [
                              _vm._v("物流信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货人："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.orderDetail.receiverName)
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货人手机："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.orderDetail.receiverPhone)
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c("div", { staticClass: "detail-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("收货地址："),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.orderDetail.receiverDetailAddr
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canPerformActions(_vm.orderDetail)
                      ? _c("div", { staticClass: "drawer-action" })
                      : _vm._e(),
                  ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dental-order-cancel-dialog",
          attrs: {
            title: "取消订单",
            visible: _vm.cancelDialogVisible,
            width: "40%",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cancelDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("p", { staticClass: "dialog-tips" }, [
                _vm._v("确定要取消该订单吗？取消后不可恢复！"),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "cancelForm",
                  attrs: {
                    model: _vm.cancelForm,
                    rules: _vm.cancelRules,
                    "label-width": "100px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "取消原因：", prop: "cancelReason" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入取消原因",
                          rows: 3,
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.cancelForm.cancelReason,
                          callback: function ($$v) {
                            _vm.$set(_vm.cancelForm, "cancelReason", $$v)
                          },
                          expression: "cancelForm.cancelReason",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cancelDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.cancelLoading },
                  on: { click: _vm.submitCancelOrder },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dental-order-address-dialog",
          attrs: {
            title: "修改预约地址",
            visible: _vm.addressDialogVisible,
            width: "50%",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addressDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "addressForm",
                  attrs: {
                    model: _vm.addressForm,
                    rules: _vm.addressRules,
                    "label-width": "120px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人：", prop: "receiverName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入收货人姓名" },
                        model: {
                          value: _vm.addressForm.receiverName,
                          callback: function ($$v) {
                            _vm.$set(_vm.addressForm, "receiverName", $$v)
                          },
                          expression: "addressForm.receiverName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话：", prop: "receiverPhone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入联系电话" },
                        model: {
                          value: _vm.addressForm.receiverPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.addressForm, "receiverPhone", $$v)
                          },
                          expression: "addressForm.receiverPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货地址：", prop: "receiverAddress" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入详细地址",
                          rows: 3,
                        },
                        model: {
                          value: _vm.addressForm.receiverAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.addressForm, "receiverAddress", $$v)
                          },
                          expression: "addressForm.receiverAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "预约诊所：", prop: "clinicId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择预约诊所",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.remoteSearchClinic,
                            loading: _vm.clinicLoading,
                          },
                          model: {
                            value: _vm.addressForm.clinicId,
                            callback: function ($$v) {
                              _vm.$set(_vm.addressForm, "clinicId", $$v)
                            },
                            expression: "addressForm.clinicId",
                          },
                        },
                        _vm._l(_vm.clinicOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.clinicName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addressDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.addressLoading },
                  on: { click: _vm.submitUpdateAddress },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dental-order-result-dialog",
          attrs: {
            title: "上传口腔检查结果",
            visible: _vm.resultDialogVisible,
            width: "50%",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.resultDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "resultForm",
                  attrs: {
                    model: _vm.resultForm,
                    rules: _vm.resultRules,
                    "label-width": "100px",
                    size: "small",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "订单编号：" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.resultForm.orderNo))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "检查结果：", prop: "result" } },
                    [
                      _c("Tinymce", {
                        attrs: { height: 300 },
                        model: {
                          value: _vm.resultForm.result,
                          callback: function ($$v) {
                            _vm.$set(_vm.resultForm, "result", $$v)
                          },
                          expression: "resultForm.result",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.resultDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.resultLoading },
                  on: { click: _vm.submitResultUpload },
                },
                [_vm._v("提 交")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dental-order-status-dialog",
          attrs: {
            title: "更改预约状态",
            visible: _vm.statusDialogVisible,
            width: "40%",
            "before-close": _vm.handleDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.statusDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "statusForm",
                  attrs: {
                    model: _vm.statusForm,
                    rules: _vm.statusRules,
                    "label-width": "100px",
                    size: "small",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "订单编号：" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.statusForm.orderNo))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "预约状态：", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择预约状态" },
                          model: {
                            value: _vm.statusForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.statusForm, "status", $$v)
                            },
                            expression: "statusForm.status",
                          },
                        },
                        _vm._l(_vm.appointmentStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: {
                              label: item.label,
                              value: item.value,
                              disabled: item.value === "",
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.statusDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.statusLoading },
                  on: { click: _vm.submitStatusChange },
                },
                [_vm._v("提 交")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }